import React, { useState, useEffect } from 'react'
import packageJson from '../package.json'
import dayjs from 'dayjs'

const buildDateGreaterThan = (latestDate, currentDate) => {
  if (dayjs(latestDate).isAfter(dayjs(currentDate))) {
    return true
  } else {
    return false
  }
}

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false)
    // ! Run npm run build if this throws an error meta.json file should be in public folder
    useEffect(() => {
      try {
        fetch('/meta.json')
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              throw new Error('Something went wrong')
            }
          })
          .then(meta => {
            const latestVersionDate = meta.buildDate
            const currentVersionDate = packageJson.buildDate

            const shouldForceRefresh = buildDateGreaterThan(latestVersionDate, currentVersionDate)

            if (shouldForceRefresh) {
              setIsLatestBuildDate(false)
              refreshCacheAndReload()
            } else {
              setIsLatestBuildDate(true)
            }
          })
          .catch(err => {
            console.log('err: ', err)
            setIsLatestBuildDate(true)
          })
      } catch (e) {
        setIsLatestBuildDate(true)
      }
    }, [])

    const refreshCacheAndReload = () => {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(names => {
          for (const name of names) {
            caches.delete(name)
          }
        })
      }
      // delete browser cache and hard reload
      window.location.reload(true)
    }

    return <React.Fragment>{isLatestBuildDate ? <Component {...props} /> : null}</React.Fragment>
  }

  return ClearCacheComponent
}

export default withClearCache
